module.exports = __webpack_public_path__ + "img/int1_mob.98b0ab1e.jpg";;
if (typeof window !== 'undefined') {
(window.__IMAGE_SIZES__ || (window.__IMAGE_SIZES__ = {}))[module.exports] = {"width":810,"height":525,"variants":[{"file":"img/int1_mob-480w.36b2e89d10e9.webp","width":480},{"file":"img/int1_mob-810w.f24e465c202a.webp","width":810}]};
}